<div class="container h-full" id="add-sale">
  <div class="row h-full">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/sales" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SALES.BTN_BACK_TO_SALE' | translate }}</a>
      </div>
    </div>
    <hr role="presentation" class="w-full mb-4 mt-0 border-t">
    <div class="col-12 grow">
      <div class="view-content-wr h-full">
        <div class="row h-full">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <h3 data-testid="add-sale-setup" class="pb-3">{{ 'SALE_CREATE.SALE_CREATION_SETUP' | translate }}</h3>

            <p-stepper class="legacy-stepper" [value]="currentStepIndex + 1" [linear]="true">
              <p-step-list>
                @for (step of saleSteps; track step; let stepIndex = $index) {
                  <p-step [value]="stepIndex + 1">
                    {{ step.label }}
                  </p-step>
                }
              </p-step-list>
            </p-stepper>

            <div class="flex flex-wrap justify-between mt-3 mb-5">
              <button data-testid="add-sale-previous-step" type="button"
                class="reset-btn border-none inline-flex items-center text-base link link-icon left-arrow-minimal"
                [ngClass]="{'disabled': currentStepIndex === 0 || isPrevButtonDisabled }" (click)="onPreviousStep()">{{ 'SALE_CREATE.BTN_PREV_STEP' |
              translate }}</button>
              <span class="text-base">{{ 'SALE_CREATE.STEP_N_OF_N' | translate: { currentStep: currentStepIndex+1,
              totalSteps: getStepsCounter() } }}</span>
            </div>
            <div class="grow">
              @switch (saleSteps[currentStepIndex]?.component) {
                @case ('sale-type') {
                  <app-sale-type (stepSaved)="onNextStep()"></app-sale-type>
                }
                @case ('serial-number-validation') {
                  <app-serial-number-validation (stepSaved)="onNextStep()"></app-serial-number-validation>
                }
                @case ('seller-details') {
                  <app-seller-details (stepSaved)="onNextStep()"></app-seller-details>
                }
                @case ('customer-details') {
                  <app-customer-details (stepSaved)="onNextStep()"></app-customer-details>
                }
                @case ('warranty-code') {
                  <app-sale-warranty-code-validation (stepSaved)="onNextStep()"></app-sale-warranty-code-validation>
                }
                @case ('sale-summary') {
                  <app-sale-summary (disablePrevBtn)="disablePrevBtn()"></app-sale-summary>
                }
              }
            </div>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

